"use client";

// useWidgetFormRenderer (spec §14): the form of a widget of the form slot, rendered with useFormRenderer.
//
//   const form = useWidgetFormRenderer(widget, { styles, on_success });   // widget: a WidgetValue with form_definition_data
//   form.render()   // the form, or null when the widget has no form (it was trashed, or never picked)
//
// Everything useFormRenderer takes is passed on; the widget adds its form (the latest version, with requires_login and the
// captcha switch of the form itself) and its id as `extra_meta.widget_id`.
import useFormRenderer from "./use_form_renderer.js";
import { widget_extra_meta, widget_form_of } from "./widget_form.js";

const useWidgetFormRenderer = (widget, options = {}) => {
    const { extra_meta, ...rest } = options;
    return useFormRenderer({
        ...rest,
        form: widget_form_of(widget) || undefined,
        // the widget names its form; a form id or key given by mistake would load another one beside it
        form_id: undefined,
        form_key: undefined,
        extra_meta: widget_extra_meta(widget, extra_meta),
    });
};

export default useWidgetFormRenderer;
